export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<{ outcome?: 'accepted' | 'dismissed' } | void>;
  userChoice?: Promise<{ outcome: 'accepted' | 'dismissed'; platform?: string }>;
};

export const PWA_INSTALLED_STORAGE_KEY = 'pranaPwaInstalled';
export const PWA_INSTALL_PROMPT_READY_EVENT = 'prana:pwa-install-prompt-ready';
export const PWA_INSTALLED_EVENT = 'prana:pwa-installed';

type PwaWindow = Window & {
  __pranaPwaInstallPrompt?: BeforeInstallPromptEvent | null;
};

const getPwaWindow = (): PwaWindow | null => {
  if (typeof window === 'undefined') return null;
  return window as PwaWindow;
};

export const getDeferredPwaInstallPrompt = (): BeforeInstallPromptEvent | null =>
  getPwaWindow()?.__pranaPwaInstallPrompt ?? null;

export const setDeferredPwaInstallPrompt = (event: BeforeInstallPromptEvent): void => {
  const target = getPwaWindow();
  if (target) target.__pranaPwaInstallPrompt = event;
};

export const clearDeferredPwaInstallPrompt = (): void => {
  const target = getPwaWindow();
  if (target) target.__pranaPwaInstallPrompt = null;
};

export const hasPwaInstalledMarker = (): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(PWA_INSTALLED_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const markPwaInstalled = (): void => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(PWA_INSTALLED_STORAGE_KEY, '1');
  } catch {
    // Storage can be unavailable in private/restricted browser contexts.
  }
};
